import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    AuthenticatorService,
    Permission,
} from '../Services/authenticator.service';
import { PingService } from '../Services/ping.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class LoggedGuard {
    constructor(
        private router: Router,
        private auth: AuthenticatorService,
        private pingService: PingService,
        private snackBar: MatSnackBar,
    ) {}

    async canLoad(): Promise<boolean> {
        const backend = await this.pingService.makePing();

        if (backend) {
            const logged: Permission = await this.auth.isLogged();
            if (!logged.access) {
                return true;
            } else {
                this.router.navigate([this.auth.userPage]);
                return false;
            }
        } else {
            return false;
        }
    }

    async canActivate(): Promise<boolean> {
        const backend = await this.pingService.makePing();

        if (backend) {
            // const token: string | undefined =
            //     await this.pingService.recaptchaV3('guardAction');
            // const recaptcha = token
            //     ? await this.pingService.validateRecapchaV3(token)
            //     : true;

            const recaptcha = true;
            
            if (recaptcha) {
                const logged: Permission = await this.auth.isLogged();
                if (!logged.access) {
                    return true;
                } else {
                    this.router.navigate([this.auth.userPage]);
                    return false;
                }
            } else {
                this.snackBar.open('Tráfico inusual procedente de tu red de computadoras', '🤖', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    panelClass: ['snack-error-message'],
                });
                return false;
            }
        } else {
            // this.snackBar.open(
            //     'El servidor no puede atender temporalmente su solicitud debido a un tiempo de inactividad por mantenimiento o problemas de capacidad. Por favor, inténtelo de nuevo más tarde.',
            //     '🤖',
            //     {
            //         duration: 3000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'right',
            //         panelClass: ['snack-error-message'],
            //     }
            // );
            return false;
        }
    }
}
